<template>
  <input
    ref="CheckBoxComponent"
    type="checkbox"
    :class="[
      {
        'border-danger-50 bg-danger-99 text-danger-50 focus:ring-primary-40': error,
        'bg-neutral-99 text-neutral-300': disabled && !error,
        'border-neutral-70 text-primary-40 focus:ring-primary-40': !disabled && !error,
      },
      ' rounded',
    ]"
    :disabled="disabled"
    :value="modelValue"
    :checked="modelValue"
    @change="onChange"
    @click="onClick"
  />
</template>

<script lang="ts" setup>
import { ref } from "vue";

// Props
withDefaults(
  defineProps<{
    disabled?: boolean;
    modelValue: boolean;
    error?: boolean;
  }>(),
  {
    disabled: false,
    error: false,
  },
);

const emit = defineEmits<{
  "update:modelValue": [boolean];
  change: [Event];
}>();

const CheckBoxComponent = ref<HTMLInputElement | null>(null);

defineExpose({
  CheckBoxComponent,
});

//Emits
const onChange = (event: Event) => {
  emit("change", event);
};

const onClick = (event: Event) => {
  event.preventDefault();
  setTimeout(() => {
    emit("update:modelValue", !(event.target as HTMLInputElement).checked);
  });
};
</script>

<style scoped>
input[type="checkbox"]:focus {
  outline-offset: 0;
  outline: none;
}
</style>
